var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabOverview(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_6762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 14.6666C5.91165 14.6666 6.95737 13.8134 7.25105 12.6598C7.34188 12.303 7.63181 11.9999 8 11.9999H12.6667M4.66667 14.6666C3.19391 14.6666 2 13.4727 2 11.9999V3.33325C2 2.22868 2.89543 1.33325 4 1.33325H10.6667C11.7712 1.33325 12.6667 2.22868 12.6667 3.33325V11.9999M4.66667 14.6666H12.6667C13.9117 14.6666 14.9574 13.8134 15.251 12.6598C15.3419 12.303 15.0349 11.9999 14.6667 11.9999H12.6667M10 4.66659H4.66667M7.33333 7.99992H4.66667",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_6762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabOverview);
export default __webpack_public_path__ + "static/media/tab-overview.38bbbd9cf16e03abb8daef59ee7760d6.svg";
export { ForwardRef as ReactComponent };